/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-02-04",
    versionChannel: "nightly",
    buildDate: "2023-02-04T00:18:50.775Z",
    commitHash: "a369e71af6ec394000892f2e000350f436ba62ae",
};
